import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
import { iconsSet as icons } from './assets/icons/icons.js';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import lodash from 'lodash'
import axios from 'axios';
import store from './store';
import helper from './helper';
import qs from 'qs';
import Loading from 'vue-loading-overlay';
import PageSizer from './globals/PageSizer.vue';
import Multiselect from 'vue-multiselect';
import VueSkeletonLoader from 'skeleton-loader-vue';
import VueMoment from 'vue-moment';

library.add(faEye)
library.add(faPlus)
library.add(faEdit)

Vue.config.productionTip = false
var token = localStorage.getItem("token");
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.timeout = 120000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.paramsSerializer = function(params) {
  return qs.stringify(params, { encoder: function(str){
    return encodeURIComponent(str);
  }});
}

// token validity duration set to 23 hours (BE at 24 hours)
// const TOKEN_DURATION = 82800000
// token timestamp set at 24 hours, FE offsets by 1 hour early
const TOKEN_OFFSET = 3600000
// file upload size limit at 1048576 bytes or 1 MB
const UPLOAD_LIMIT = 1048576
// available login roles
const AVAIL_ROLES = {
  "HO": 1,
  "FIMS": 2,
  "Cabang": 3,
  "Notaris": 4,
  "PPAT": 5,
  "Finance": 6
}
// commonly used keywords
// const TOKEN_KEYWORD = "fimsToken"
// const TOKEN_CLOCK_KEYWORD = "fimsTokenClock"
// const USER_ID_KEYWORD = "fimsUserId"
// const USER_NAME_KEYWORD = "fimsUserName"
// const ROLE_ID_KEYWORD = "fimsRoleId"
// const LOCK_KEY_KEYWORD = "fimsLockKey"
// const ROLE_NAME_KEYWORD = "fimsRoleName"
// const SOURCE_KEYWORD = "source"

router.beforeEach((to, from, next) => {
  const basicRoutes = [
    'Login',
    'Register',
    'Forgot Password',
    'Account Activation'
  ]
  const allowedRoutesCabang = [
    'Dashboard',
    'Fiducia List',
    'Fiducia Detail',
    'Roya List',
    'Roya Detail',
    'APHT List Created',
    'APHT List Need Approval',
    'APHT Add',
    'APHT Edit',
    'APHT Detail',
    'Validation Fiducia List',
    'Validation Roya List',
    'Invoice Fiducia List',
    'Invoice Paid Fiducia List',
    'Invoice Fiducia Add',
    'Invoice Fiducia Detail',
    'Invoice Roya List',
    'Invoice Paid Roya List',
    'Invoice Roya Add',
    'Invoice Roya Detail',
    'Invoice APHT List',
    'Invoice APHT Approved List',
    'Invoice APHT Memo List',
    'Invoice APHT Add',
    'Invoice APHT Edit',
    'Invoice APHT Detail',
    'Invoice APHT Approved Detail',
    'Invoice APHT Approved Memo Detail'
  ]
  const allowedRoutesFIMS = [
    'Dashboard',
    'Fiducia List',
    'Fiducia Detail',
    'Roya List',
    'Roya Detail',
    'APHT List Created',
    'APHT Detail',
    'Validation Fiducia List',
    'Validation Roya List',
    'Invoice Fiducia List',
    'Invoice Paid Fiducia List',
    'Invoice Fiducia Add',
    'Invoice Fiducia Detail',
    'Invoice Roya List',
    'Invoice Paid Roya List',
    'Invoice Roya Add',
    'Invoice Roya Detail',
    'Invoice APHT Approved List',
    'Invoice APHT Memo List',
    'Invoice APHT Approved Detail',
    'Invoice APHT Approved Memo Detail',
    'Notaris List',
    'Notaris Add',
    'Notaris Detail',
    'Notaris Edit',
    'Assign Contract List',
    'Assign Contract Fiducia',
    'Assign Contract Roya',
    'MOU Add',
    'MOU Edit',
    'User List',
  ]
  const allowedRoutesHO = [
    'Dashboard',
    'Fiducia List',
    'Fiducia Detail',
    'Roya List',
    'Roya Detail',
    'APHT List Created',
    'APHT Detail',
    'Validation Fiducia List',
    'Validation Roya List',
    'Invoice Fiducia List',
    'Invoice Paid Fiducia List',
    'Invoice Fiducia Add',
    'Invoice Fiducia Detail',
    'Invoice Roya List',
    'Invoice Paid Roya List',
    'Invoice Roya Add',
    'Invoice Roya Detail',
    'Invoice APHT Approved List',
    'Invoice APHT Memo List',
    'Invoice APHT Approved Detail',
    'Invoice APHT Approved Memo Detail',
    'Notaris List',
    'Notaris Add',
    'Notaris Detail',
    'Notaris Edit',
    'Assign Contract List',
    'Assign Contract Fiducia',
    'Assign Contract Roya',
    'MOU Add',
    'MOU Edit',
    'User List',
    'Config Parameter List',
    'Config Script List',
    'Config Script Add',
    'Config Script Edit',
    'Config Document List',
    'Config Document Add',
    'Config Document Edit',
    'Config Principal List',
    'Config Scheduler List',
    'Config Approval List',
    'Config Approval Detail',
    'Config Payment Status',
    'Config Assignment Roya',
    'Config Role List',
    'Logs Server List',
    'Logs Security List',
    'Logs Transaction List'
  ]
  const allowedRoutesNotaris = [
    'Dashboard',
    'Fiducia List',
    'Fiducia Detail',
    'Roya List',
    'Roya Detail',
    'Invoice Fiducia List',
    'Invoice Paid Fiducia List',
    'Invoice Fiducia Add',
    'Invoice Fiducia Detail',
    'Invoice Roya List',
    'Invoice Paid Roya List',
    'Invoice Roya Add',
    'Invoice Roya Detail',
  ]

  // check token expiry if already logged in
  // const tokenClock = localStorage.getItem(TOKEN_CLOCK_KEYWORD);
  const tokenClock = store.state.tokenClock;
  if (tokenClock){
    // get current time + FE TOKEN_OFFSET (1 hour)
    const now = new Date().getTime() + TOKEN_OFFSET
    // if current time + offset has passed BE token timestamp (24 hours) since last login
    if(now > tokenClock){
      axios.defaults.headers.common['Authorization'] = ""
      // localStorage.removeItem(TOKEN_CLOCK_KEYWORD)
      store.commit('set', ['tokenClock', ""]);
      // localStorage.removeItem(TOKEN_KEYWORD)
      store.commit('set', ['token', ""]);
      return next({ name:'Login' })
    }
  }

  // token = localStorage.getItem(TOKEN_KEYWORD); //Don't use global token above;
  token = store.state.token; //Don't use global token above;
  axios.defaults.headers.common['Authorization'] = token;
  // always allow access to 404
  if (to.name == "Page 404"){
    return next()
  }
  // check before accessing basic routes
  else if (basicRoutes.includes(to.name)){
    // redirect if already logged in
    if(token){
      return next({ name: 'Dashboard' })
    }
    // allow if not yet logged in
    else{
      return next()
    }
  }
  // check before accessing routes requiring login
  else{
    // check role access if logged in
    if(token){
      // for role HO, if route is not allowed
      if(AVAIL_ROLES["HO"] == store.state.roleId && !allowedRoutesHO.includes(to.name)){
        return next({ name: 'Page 404', params: { pathMatch: to.path } })
      }
      // for role FIMS, if route is not allowed
      else if(AVAIL_ROLES["FIMS"] == store.state.roleId && !allowedRoutesFIMS.includes(to.name)){
        return next({ name: 'Page 404', params: { pathMatch: to.path } })
      }
      // for role Cabang, if route is not allowed
      else if(AVAIL_ROLES["Cabang"] == store.state.roleId && !allowedRoutesCabang.includes(to.name)){
        return next({ name: 'Page 404', params: { pathMatch: to.path } })
      }
      // for role NOTARIS, if route is not allowed
      else if(AVAIL_ROLES["Notaris"] == store.state.roleId && !allowedRoutesNotaris.includes(to.name)){
        return next({ name: 'Page 404', params: { pathMatch: to.path } })
      }
      // if route is allowed
      else{
        return next()
      }
    }
    // return to login if not yet logged in
    else{
      axios.defaults.headers.common['Authorization'] = ""
      // localStorage.removeItem(TOKEN_CLOCK_KEYWORD)
      store.commit('set', ['tokenClock', ""]);
      // localStorage.removeItem(TOKEN_KEYWORD)
      store.commit('set', ['token', ""]);
      // localStorage.removeItem(USER_ID_KEYWORD)
      store.commit('set', ['userId', ""]);
      // localStorage.removeItem(USER_NAME_KEYWORD)
      store.commit('set', ['userName', ""]);
      // localStorage.removeItem(ROLE_ID_KEYWORD)
      store.commit('set', ['roleId', ""]);
      // localStorage.removeItem(LOCK_KEY_KEYWORD)
      store.commit('set', ['lockKey', ""]);
      // localStorage.removeItem(ROLE_NAME_KEYWORD)
      // localStorage.removeItem(SOURCE_KEYWORD)
      store.commit('set', ['source', ""]);
      return next({ name: 'Login' })
    }
  }
})
let errorLabel = {
  generic: 'Error!',
  emptyField: '-'
};

Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(VueMoment);
Vue.component('Loading', Loading)
Vue.component('Multiselect', Multiselect);
Vue.component('Skeleton', VueSkeletonLoader);
Vue.component('PageSizer', PageSizer);
Vue.component('FaIcon', FontAwesomeIcon)
Vue.prototype.$lodash = lodash;
Vue.prototype.$axios = axios;
Vue.prototype.$helper = helper;
Vue.prototype.$errorLabel = errorLabel;
Vue.prototype.$appType = 'FIMS_';
Vue.prototype.$realm = 'fims';
Vue.prototype.$uploadLimit = UPLOAD_LIMIT;
Vue.prototype.$availRoles = AVAIL_ROLES;
// Vue.prototype.$tokenKeyword = TOKEN_KEYWORD;
// Vue.prototype.$tokenClockKeyword = TOKEN_CLOCK_KEYWORD;
// Vue.prototype.$userIdKeyword = USER_ID_KEYWORD;
// Vue.prototype.$userNameKeyword = USER_NAME_KEYWORD;
// Vue.prototype.$roleIdKeyword = ROLE_ID_KEYWORD;
// Vue.prototype.$lockKeyKeyword = LOCK_KEY_KEYWORD;
// Vue.prototype.$roleNameKeyword = ROLE_NAME_KEYWORD;
// Vue.prototype.$sourceKeyword = SOURCE_KEYWORD;

const rootApp = new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App></App>',
  components: {
    App,
  },
});

rootApp;
